/**
 * AddButton Component
 *
 * Extracted from Figma Crop Circle System
 * Node ID: 467-452
 */

export { AddButton } from './AddButton';
export type { AddButtonProps } from './AddButton';
